'use client';

import { useState, useEffect } from 'react';

export function useDarkMode() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('vq_dark_mode') === 'true';
    setDarkMode(stored);
    if (stored) {
      document.documentElement?.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement?.removeAttribute('data-theme');
    }
  }, []);

  const toggleDarkMode = () => {
    const next = !darkMode;
    setDarkMode(next);
    localStorage.setItem('vq_dark_mode', String(next));
    if (next) {
      document.documentElement?.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement?.removeAttribute('data-theme');
    }
  };

  return { darkMode, toggleDarkMode };
}
